/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamDisciplineSingleQueryResponse,
  GetApiV1ExamDisciplineSingleQueryParams,
  GetApiV1ExamDisciplineSingle400,
  GetApiV1ExamDisciplineSingle401,
  GetApiV1ExamDisciplineSingle500,
} from "../../types/examSharedController/GetApiV1ExamDisciplineSingle.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamDisciplineSingle } from "../../clients/examSharedController/getApiV1ExamDisciplineSingle.ts";

export const getApiV1ExamDisciplineSingleQueryKey = (
  params?: GetApiV1ExamDisciplineSingleQueryParams,
) =>
  [
    { url: "/api/v1/exam/discipline-single" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamDisciplineSingleQueryKey = ReturnType<
  typeof getApiV1ExamDisciplineSingleQueryKey
>;

export function getApiV1ExamDisciplineSingleQueryOptions(
  params?: GetApiV1ExamDisciplineSingleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamDisciplineSingleQueryKey(params);
  return queryOptions<
    GetApiV1ExamDisciplineSingleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineSingle400
      | GetApiV1ExamDisciplineSingle401
      | GetApiV1ExamDisciplineSingle500
    >,
    GetApiV1ExamDisciplineSingleQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamDisciplineSingle(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna disciplinas filtradas pelo texto informado no nome ou código. Quando o id é informado, retorna apenas a disciplina correspondente. Filtra pela empresa quando companyId é fornecido. **(Requer Authorization para autenticação)**
 * @summary Buscar disciplinas por nome (Requer Authorization para autenticação)
 * {@link /api/v1/exam/discipline-single}
 */
export function useGetApiV1ExamDisciplineSingle<
  TData = GetApiV1ExamDisciplineSingleQueryResponse,
  TQueryData = GetApiV1ExamDisciplineSingleQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamDisciplineSingleQueryKey,
>(
  params?: GetApiV1ExamDisciplineSingleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamDisciplineSingleQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamDisciplineSingle400
          | GetApiV1ExamDisciplineSingle401
          | GetApiV1ExamDisciplineSingle500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamDisciplineSingleQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamDisciplineSingleQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamDisciplineSingle400
      | GetApiV1ExamDisciplineSingle401
      | GetApiV1ExamDisciplineSingle500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
